import MedicineDictionaryModel from '@/entities/medicine-dictionary/model/medicineDictionary.model';
import { formatKeywordForUrl } from '@/shared/utils/format';
import { ROUTES } from '@/types/common';

export const sanitizeHtml = (html: string): string => {
  // tbody가 p 태그 안에 있는 경우를 처리
  let sanitized = html.replace(/<p><tbody>/g, '<table><tbody>');
  sanitized = sanitized.replace(/<\/tbody><\/p>/g, '</tbody></table>');

  // 테이블 스타일링을 위한 클래스 추가
  sanitized = sanitized.replace(
    /<table>/g,
    '<table class="w-full border-collapse border border-gray-200 my-4 rounded-lg overflow-hidden">'
  );
  sanitized = sanitized.replace(/<td/g, '<td class="border border-gray-200 px-4 py-3 text-center bg-white"');
  sanitized = sanitized.replace(/<tr>/g, '<tr class="hover:bg-gray-50">');

  // 첫 번째 행(헤더)에 다른 스타일 적용
  sanitized = sanitized.replace(/(<tr class="hover:bg-gray-50">[\s\S]*?<\/tr>)/, (match) => {
    return match.replace('bg-white', 'bg-gray-100 font-medium');
  });

  return sanitized;
};

export const getMedicineDictionaryImageUrl = (image?: string, packagingInfoImage?: string): string | undefined => {
  return image ?? packagingInfoImage ?? undefined;
};

export const createMedicineDictionaryDetailUrl = (medicineDictionary?: MedicineDictionaryModel): string => {
  if (!medicineDictionary) {
    return '';
  }
  const publicId = medicineDictionary.getPublicId();
  const keyword = medicineDictionary.getBasicInfoName() || medicineDictionary.getSimplifiedName();
  const encodedKeyword = formatKeywordForUrl(keyword);

  return `${ROUTES.MEDICINE_DICTIONARY.DETAIL.path}/${publicId}/${encodedKeyword}`;
};

export const createMedicineDictionaryDetailUrlWithKeyword = (publicId: string, keyword: string): string => {
  const encodedKeyword = formatKeywordForUrl(keyword);
  return `${ROUTES.MEDICINE_DICTIONARY.DETAIL.path}/${publicId}/${encodedKeyword}`;
};

const extractKeywordFromMedicineData = (medicineData: any): string => {
  return medicineData.basicInfo.name || medicineData.basicInfo.simplifiedName;
};

export const createMedicineDictionaryRedirectUrl = (publicId: string, medicineData: any): string => {
  const keyword = extractKeywordFromMedicineData(medicineData);
  const formattedKeyword = formatKeywordForUrl(keyword);
  const encodedKeyword = encodeURIComponent(formattedKeyword);
  return `${ROUTES.MEDICINE_DICTIONARY.DETAIL.path}/${publicId}/${encodedKeyword}`;
};
